import React from 'react';
import { BellIcon, XIcon } from 'lucide-react';
interface MobileNotificationProps {
  title: string;
  message: string;
  time?: string;
  variant?: 'standard' | 'milestone' | 'reward';
  contextIcon?: React.ReactNode;
}
export const MobileNotification: React.FC<MobileNotificationProps> = ({
  title,
  message,
  time = 'Nu',
  variant = 'standard',
  contextIcon
}) => {
  return <div className="max-w-[360px] bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" data-id="element-1544">
      <div className="flex items-center p-3 border-b border-gray-100" data-id="element-1545">
        <div className="h-8 w-8 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3" data-id="element-1546">
          <HeartPulseIcon className="h-4 w-4 text-[#d4af37]" data-id="element-1547" />
        </div>
        <div className="flex-1" data-id="element-1548">
          <div className="flex items-center justify-between" data-id="element-1549">
            <p className="text-sm font-medium text-gray-800" data-id="element-1550">Mosy</p>
            <p className="text-xs text-gray-500" data-id="element-1551">{time}</p>
          </div>
          <p className="text-xs text-gray-500" data-id="element-1552">Mentale gezondheid</p>
        </div>
      </div>
      <div className="p-4" data-id="element-1553">
        <div className="flex items-start" data-id="element-1554">
          {variant === 'milestone' && <div className="h-8 w-8 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 flex-shrink-0" data-id="element-1555">
              <AwardIcon className="h-4 w-4 text-[#d4af37]" data-id="element-1556" />
            </div>}
          {variant === 'reward' && <div className="h-8 w-8 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 flex-shrink-0" data-id="element-1557">
              <GiftIcon className="h-4 w-4 text-[#d4af37]" data-id="element-1558" />
            </div>}
          {variant === 'standard' && <div className="h-8 w-8 rounded-full bg-[#f7f3ef] flex items-center justify-center mr-3 flex-shrink-0" data-id="element-1559">
              {contextIcon || <BellIcon className="h-4 w-4 text-[#d4af37]" data-id="element-1560" />}
            </div>}
          <div className="flex-1" data-id="element-1561">
            <h4 className="text-sm font-medium text-gray-800 mb-1" data-id="element-1562">{title}</h4>
            <p className="text-sm text-gray-600" data-id="element-1563">{message}</p>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-100" data-id="element-1564">
        <button className="flex-1 p-3 text-sm text-[#d4af37] font-medium border-r border-gray-100" data-id="element-1565">
          Bekijken
        </button>
        <button className="flex-1 p-3 text-sm text-gray-500" data-id="element-1566">Later</button>
      </div>
    </div>;
};
import { HeartPulseIcon, AwardIcon, GiftIcon } from 'lucide-react';